<script>import InputSelect from "../../elements/inputs/variants/InputSelect.svelte";
import Search from "../Search.svelte";
export let filters;
export let withSearch;
export let searchProps;
export let columnIndexToSearch;
export let onClickSelect;
</script>

<div class="grid grid-cols-1 lg:grid-cols-4 gap-3 lg:items-end pb-3 z10">
	{#if filters}
		<div class="grid grid-cols-1 gap-3 lg:grid-cols-3 xl:grid-cols-4 lg:col-span-3">
			{#each filters as f, i}
				{#if f}
					<InputSelect
						bind:props={f}
						on:click={() => {
							onClickSelect(f, i);
						}}
					/>
				{/if}
			{/each}
		</div>
	{/if}
	{#if withSearch && columnIndexToSearch >= 0}
		<Search bind:props={searchProps} />
	{/if}
</div>
